import { Component, createRef } from 'react';

class DoubleScrollbar extends Component {
  constructor(props) {
    super(props);
    this.outerDiv = createRef();
    this.childrenWrapper = createRef();
    this.innerDiv = createRef();

    this.state = {
      width: 'auto',
    };

    this.boundCalculateWidth = this.calculateWidth.bind(this);
  }

  componentDidMount() {
    // Set initial width
    this.calculateWidth();

    // Update width when window size changes
    window.addEventListener('resize', this.boundCalculateWidth);

    // assoc the scrolls
    this.outerDiv.current.onscroll = () => {
      this.childrenWrapper.current.scrollLeft =
        this.outerDiv.current.scrollLeft;
    };

    this.childrenWrapper.current.onscroll = () => {
      this.outerDiv.current.scrollLeft =
        this.childrenWrapper.current.scrollLeft ?? 0;
    };
  }

  componentDidUpdate() {
    this.calculateWidth();

    window.removeEventListener('resize', this.boundCalculateWidth);
  }

  getChildWrapperWidth() {
    let width = null;
    if (
      this.childrenWrapper.current &&
      this.childrenWrapper.current.scrollWidth
    ) {
      width = `${this.childrenWrapper.current.scrollWidth}px`;
    }
    return width;
  }

  calculateWidth() {
    const { width } = this.state;
    let widthWrapper = this.getChildWrapperWidth();

    if (widthWrapper == null) {
      widthWrapper = 'auto';
    }

    // Set the width of the inner div to the first child's
    if (widthWrapper !== width) {
      this.setState({
        width: widthWrapper,
      });
    }
  }

  render() {
    const { children, totalData } = this.props;
    const { width } = this.state;

    const outerDivStyle = {
      overflow: 'auto',
      height: '10px',
      backgroundColor: 'var(--token-color-blue5)',
    };
    const innerDivStyle = { width };
    const childDivStyle = {
      overflow: 'auto',
      height: totalData > 10 ? '640px' : 'auto',
      border: '1px solid rgba(0, 0, 0, 0.125)',
      borderBottom: 'none',
    };

    return (
      <>
        <div ref={this.outerDiv} style={outerDivStyle}>
          <div ref={this.innerDiv} style={innerDivStyle}>
            &nbsp;
          </div>
        </div>
        <div ref={this.childrenWrapper} style={childDivStyle}>
          {children}
        </div>
      </>
    );
  }
}

export default DoubleScrollbar;
